export default function OptionContent({ title, description, danger }: { title: string, description?: string, danger?: boolean }) {
    return (
        <>
            <h4 className={`font-semibold ${danger ? 'text-red-600' : 'text-gray-900'}`}>{title}</h4>
            {description ? <p className='font-normal text-sm text-gray-500 max-w-[17.5rem] whitespace-normal'>{description}</p> : ''}
        </>
    )
}
